"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  min-height: 40px;\n  width: 40px;\n  border-radius: ", ";\n  border: solid 1px ", ";\n  overflow: hidden;\n  text-align: center;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  padding: 0px;\n  cursor: pointer;\n  &::-webkit-color-swatch,\n  &::-moz-color-swatch {\n    border: none !important;\n    border-color: transparent;\n  }\n  &::-webkit-color-swatch-wrapper {\n    padding: 0;\n    border: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._ColorInput = exports.ColorInput = void 0;

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Reset_1 = require("./Reset");

exports.ColorInput = react_1["default"].forwardRef(function (_a, ref) {
  var _onChange = _a.onChange,
      rest = __rest(_a, ["onChange"]);

  return react_1["default"].createElement(exports._ColorInput, Object.assign({
    type: 'color'
  }, rest, {
    ref: ref,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e.target.value);
      }
    }
  }));
});
exports._ColorInput = (0, styled_components_1["default"])(Reset_1.Reset.Input)(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@border-color-split'];
}, function (props) {
  return props.theme['@font-size-base'];
}, function (props) {
  return props.theme['@line-height-base'];
}, function (props) {
  return props.theme['@text-color'];
});